/* Click-and-drag scrolling for the migrated-page gallery scroll rows, matching the feel of the
   native Horizon carousels (which drag without a scrollbar). Applies to any element carrying
   .sw-drag-scroll OR the resurrected Smart Slider gallery rows (see softwoods-custom.css,
   "Resurrect image-gallery Smart Sliders" — same :not() guard keeps the hidden timber-species
   slider untouched). Scroll-snap is suspended during the drag so it doesn't fight the pointer,
   then restored so release still settles on a card edge. Click-through is suppressed after a
   real drag so image links don't fire. */
(function () {
  var SELECTOR = '.sw-drag-scroll, .page-content .n2-section-smartslider';

  function enable(el) {
    if (el.dataset.swDrag) return;
    // skip rows that aren't actually scrollable (e.g. display:none timber slider)
    if (getComputedStyle(el).display === 'none') return;
    el.dataset.swDrag = '1';
    el.style.cursor = 'grab';

    // images hijack mouse drags via native HTML5 drag-and-drop (pointercancel fires and the
    // row never scrolls) — disable it inside the row
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var down = false, moved = false, startX = 0, startLeft = 0, snap = '';

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return; // touch already pans natively
      down = true; moved = false;
      startX = e.clientX; startLeft = el.scrollLeft;
      snap = el.style.scrollSnapType;
      el.style.scrollSnapType = 'none';
      el.style.cursor = 'grabbing';
      el.setPointerCapture(e.pointerId);
    });

    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = startLeft - dx;
    });

    function release(e) {
      if (!down) return;
      down = false;
      el.style.scrollSnapType = snap;
      el.style.cursor = 'grab';
      if (el.hasPointerCapture && el.hasPointerCapture(e.pointerId)) {
        el.releasePointerCapture(e.pointerId);
      }
    }
    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);

    // a drag must not trigger the click/navigation under the cursor
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(enable);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
